module.exports = __webpack_public_path__ + "static/media/siterraBg3.a95d0fde.jpg";